export default __webpack_public_path__ + "locales/pt/EmbeddingPanel.json?hash=8c4d52c90af6439762adab0c56593692";